module.exports = __webpack_public_path__ + "assets/87601e3fa685a58eb2b6c4fa029f6d0a.mp3";